<template>
  <div class="introduction">
    <div class="top_b">
      <div class="container in_nav">
        <div class="row">
          <div class="col-sm-4 text-center">
            <router-link active-class="i_active" to="/introduction">公司简介</router-link>
          </div>
          <div class="col-sm-4 text-center">
            <router-link active-class="i_active" to="/hope">愿景和价值观</router-link>
          </div>
          <div class="col-sm-4 text-center">
            <router-link active-class="i_active" to="/honor">荣誉资质</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="container honor">
      <div class="row">
        <div class="col-lg-3 col-sm-6 col-xs-6">
          <img src="../../assets/Certificate_pic01.png" alt="">
        </div>
        <div class="col-lg-3 col-sm-6 col-xs-6">
          <img src="../../assets/Certificate_pic02.png" alt="">
        </div>
        <div class="col-lg-3 col-sm-6 col-xs-6">
          <img src="../../assets/Certificate_pic03.png" alt="">
        </div>
        <div class="col-lg-3 col-sm-6 col-xs-6">
          <img src="../../assets/Certificate_pic04.png" alt="">
        </div>
      </div>
      <div class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="row">
              <div class="col-xs-4">
                <img src="../../assets/Copyright_pic01.jpg" alt="">
              </div>
              <div class="col-xs-4">
                <img src="../../assets/Copyright_pic02.jpg" alt="">
              </div>
              <div class="col-xs-4">
                <img src="../../assets/Copyright_pic03.jpg" alt="">
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="row">
              <div class="col-xs-4">
                <img src="../../assets/Copyright_pic04.jpg" alt="">
              </div>
              <div class="col-xs-4">
                <img src="../../assets/Copyright_pic05.jpg" alt="">
              </div>
              <div class="col-xs-4">
                <img src="../../assets/Copyright_pic06.jpg" alt="">
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div class="row">
              <div class="col-xs-4">
                <img src="../../assets/Copyright_pic07.jpg" alt="">
              </div>
              <div class="col-xs-4">
                <img src="../../assets/Copyright_pic08.jpg" alt="">
              </div>
              <div class="col-xs-4">
                <img src="../../assets/Copyright_pic09.jpg" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
      <div class="swiper-container swiper2">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <div class="row">
              <div class="col-xs-4">
                <img src="../../assets/other_pic04.png" alt="">
              </div>
              <div class="col-xs-4">
                <img src="../../assets/other_pic05.png" alt="">
              </div>
              <div class="col-xs-4">
                <img src="../../assets/other_pic08.png" alt="">
              </div>

            </div>
          </div>
           <div class="swiper-slide">
            <div class="row">
              <div class="col-xs-4">
                <img src="../../assets/other_pic03.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Footer from '../../components/Footer'
  import Swiper from 'swiper'
  export default {
    name: 'Introduction',
    components: {
      Footer
    },
    mounted() {
      new Swiper('.swiper-container', {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
      });
      new Swiper('.swiper2', {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 8000,
          disableOnInteraction: false,
        },
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
      });
    },
    props: {}
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  img {
    width: 100%;
  }
  .introduction {

  }

  .top_b {
    height: 350px;
    background: url("../../assets/Introduction_banner.png") no-repeat center center;
    background-size: cover;
    position: relative;
    margin-bottom: 100px;
  }

  .in_nav {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: -30px;
    background: #fff;
    box-shadow: 1px 2px 20px rgba(0, 0, 0, .3);
    padding: 0px;
  }

  .in_nav a {
    padding: 20px 20px;
    display: block;
    font-size: 20px;
    color: #333;
  }

  .i_active {
    color: #fff !important;
    font-size: 20px;
    background: #ff9900;
  }
  .honor .row>div {
    margin-bottom: 30px;
  }
  .honor {
    margin-bottom: 6rem;
  }
  @media (max-width: 768px) {
    .in_nav {
      bottom: -105px;
    }
    .top_b {
      margin-bottom: 150px;
    }

  }
</style>
